<template>
  <div class="spin" />
</template>

<script>
export default {
  name: 'AmSpin',
}
</script>

<style lang="scss" scoped>
.spin {
  border: 2px solid transparent;
  border-top: 2px solid $dark-40;
  border-right: 2px solid $dark-40;
  border-bottom: 2px solid $dark-40;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
